import List from './List';
import CreateUpdate from './CreateUpdate';
import ModalForm from './ModalForm';

export default { List, CreateUpdate, ModalForm };
